import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['emailInput', 'continueButton'];

  connect() {
    if (this.hasContinueButtonTarget) this.continueButtonTarget.disabled = true;

    if (this.hasEmailInputTarget)
      this.listener = this.emailInputTarget.addEventListener('input', () => {
        this.continueButtonTarget.disabled =
          !this.emailInputTarget.checkValidity();
      });
  }

  disconnect() {
    if (this.listener && this.hasEmailInputTarget)
      this.emailInputTarget.removeEventListener('input', this.listener);
  }
}
